module.exports = __webpack_public_path__ + "img/WE_blog4.3bc97235.png";